import { Injectable } from '@angular/core';
import { WHITELABEL_COVER_PAGE_RESPONSE } from '@constants/whitelabel-cover-page.generated';
import type { WhitelabelCoverPageApiData } from '@modules/whitelabel-cover-page/whitelabel-cover-page.interface';

@Injectable({
  providedIn: 'root'
})
export class WhitelabelCoverPageCacheService {
  private coverPage: WhitelabelCoverPageApiData | null = null;

  set(data: WhitelabelCoverPageApiData | null | undefined): void {
    if (!this.hasCoverPage(data)) {
      return;
    }
    this.coverPage = data;
  }

  get(): WhitelabelCoverPageApiData | null {
    if (this.hasCoverPage(this.coverPage)) {
      return this.coverPage;
    }
    const generated = WHITELABEL_COVER_PAGE_RESPONSE?.data as
      | WhitelabelCoverPageApiData
      | undefined;
    return this.hasCoverPage(generated) ? generated : null;
  }

  private hasCoverPage(
    data: WhitelabelCoverPageApiData | null | undefined
  ): data is WhitelabelCoverPageApiData {
    return !!(
      data &&
      typeof data === 'object' &&
      (data.page_id != null || data.pk || data.creator_id)
    );
  }
}
